export default "__VITE_ASSET__CKriWbiV__"